{
  "NETWORK_ERROR": "The server cannot be reached. Check the connection and try again.",
  "VALIDATION_FAILED": "Some fields are not valid.",
  "UNAUTHENTICATED": "Sign in to continue.",
  "SESSION_EXPIRED": "Your session has ended. Sign in again.",
  "FORBIDDEN": "Your role does not allow this.",
  "NOT_FOUND": "This item no longer exists.",
  "CONFLICT": "This value is already used.",
  "RATE_LIMITED": "Too many attempts. Wait a moment and try again.",
  "ORIGIN_NOT_ALLOWED": "This request was refused for security reasons.",
  "SERVICE_UNAVAILABLE": "A service is temporarily unavailable. Try again shortly.",
  "INTERNAL_ERROR": "Something went wrong on our side. Try again.",
  "AUTH_INVALID_CREDENTIALS": "Wrong username or password.",
  "AUTH_ACCOUNT_LOCKED": "Too many wrong passwords: the account is locked. Try again in {{minutes}} min, or ask an administrator.",
  "AUTH_ACCOUNT_DEACTIVATED": "This account is deactivated. Ask your administrator.",
  "AUTH_PASSWORD_CHANGE_REQUIRED": "Choose a new password before continuing.",
  "AUTH_INVALID_CURRENT_PASSWORD": "The current password is not correct.",
  "AUTH_PASSWORD_REUSED": "Choose a password you have not used before.",
  "AUTH_RESET_TOKEN_INVALID": "This link is invalid or has expired.",
  "USER_USERNAME_TAKEN": "This username is already used.",
  "USER_EMAIL_TAKEN": "This email is already used by another person.",
  "USER_CANNOT_DEACTIVATE_SELF": "You cannot deactivate your own account.",
  "USER_LAST_ADMIN": "The company must keep at least one active administrator.",
  "USER_INVALID_LOCATIONS": "Some locations cannot be assigned (inactive or removed).",
  "ROLE_LOCKED": "The administrator role always has every permission.",
  "REFERENCE_IN_USE_one": "Used by {{count}} record: deactivate it instead.",
  "REFERENCE_IN_USE_other": "Used by {{count}} records: deactivate it instead.",
  "REFERENCE_SYSTEM_LOCKED": "This value is used by the system: it can be renamed, not removed.",
  "REFERENCE_DUPLICATE": "This name is already used.",
  "CATEGORY_CYCLE": "A category cannot be placed inside itself.",
  "CATEGORY_HAS_CHILDREN": "Move or delete its sub-categories first.",
  "CATEGORY_PARENT_INACTIVE": "The parent category is deactivated.",
  "SEQUENCE_PREFIX_TAKEN": "Another document type or a sales channel already uses this prefix.",
  "SEQUENCE_LOCKED": "This numbering cannot be changed.",
  "LANGUAGE_DEFAULT_DISABLED": "The company default language must stay enabled.",
  "FILE_REQUIRED": "Choose a file.",
  "FILE_TYPE_NOT_ALLOWED": "This file type is not accepted.",
  "FILE_TOO_LARGE": "This file is too large.",
  "IMMUTABLE_RECORD": "Activity log records can never be changed.",
  "PRODUCT_SKU_TAKEN": "This SKU already belongs to another product.",
  "PRODUCT_SKU_LOCKED": "The SKU cannot change once the product has moved.",
  "PRODUCT_BARCODE_TAKEN": "This barcode already belongs to another product.",
  "PRODUCT_HAS_STOCK": "The stock must be zero in every location to archive this product.",
  "PRODUCT_IN_USE": "This product has history: archive it instead.",
  "PRODUCT_ARCHIVED": "This product is archived. Restore it first.",
  "PRODUCT_REFERENCE_INACTIVE": "The category, brand or unit is missing or deactivated.",
  "PRODUCT_QUANTITY_DECIMALS": "The unit does not allow that many decimals.",
  "PRODUCT_HAS_VARIANTS": "This product has variants: choose one of them. A product with variants holds no stock itself.",
  "LOCATION_CODE_TAKEN": "Another location already uses this code.",
  "LOCATION_SYSTEM_LOCKED": "The system location cannot be changed.",
  "LOCATION_PARENT_INVALID": "Zones, shelves and bins belong directly to a site (two levels only).",
  "LOCATION_PARENT_INACTIVE": "This site is deactivated: reactivate it first.",
  "LOCATION_HAS_STOCK": "Move or issue all the stock of this location first.",
  "LOCATION_HAS_CHILDREN": "Delete its zones, shelves and bins first.",
  "LOCATION_IN_USE": "This location is in use: deactivate it instead.",
  "IMPORT_FILE_INVALID": "This file cannot be imported. Use the template, or an Excel or CSV file with name, category and unit columns.",
  "IMPORT_FILE_EMPTY": "The file has no product row.",
  "IMPORT_TOO_MANY_ROWS": "The file has too many rows: split it into files of 50,000 rows or less.",
  "IMPORT_NOT_READY": "This import is not ready, or it is already running.",
  "IMPORT_NOTHING_TO_IMPORT": "No row can be imported: fix the file first.",
  "EXPORT_UNKNOWN_LIST": "This list cannot be exported.",
  "OPERATION_NOT_EDITABLE": "Only a draft can be changed.",
  "OPERATION_INCOMPLETE": "Some information is missing or not valid: see the fields in red.",
  "OPERATION_NOT_PENDING": "This operation is not waiting for approval any more.",
  "OPERATION_NOT_REVERSIBLE": "Only a validated operation can be reversed, once.",
  "OPERATION_LOCATION_INVALID": "This location cannot be used here.",
  "STOCK_NEGATIVE_CONFIRMATION_REQUIRED": "Some quantities will go below zero: confirm to continue.",
  "STOCK_NEGATIVE_BLOCKED": "Negative stock is blocked in Configuration.",
  "STOCK_NEGATIVE_NOT_ALLOWED": "Only people allowed to confirm negative stock can do this: ask a manager.",
  "BACKUP_RUNNING": "A backup is already running.",
  "BACKUP_NOT_READY": "This backup is not ready.",
  "STOCK_FROZEN": "These products are being counted ({{number}}): wait until the count ends.",
  "TRANSFER_NOT_IN_TRANSIT": "This transfer is not waiting to be received any more.",
  "TRANSFER_DIRECT_NOT_ALLOWED": "One-step transfers between sites need the quick transfer permission.",
  "COUNT_WRONG_STATUS": "This count cannot do that at this step.",
  "COUNT_NOT_FINISHED_one": "{{count}} product is not counted yet.",
  "COUNT_NOT_FINISHED_other": "{{count}} products are not counted yet.",
  "COUNT_OVERLAP": "Some of these products are already being counted ({{number}}).",
  "CUSTOMER_IN_USE": "This customer has orders, an online account or merged records: anonymize it instead of deleting it.",
  "CUSTOMER_NOT_ACTIVE": "This customer was merged or anonymized: it can no longer be changed.",
  "CUSTOMER_MERGE_SAME": "A customer cannot be merged into itself.",
  "CUSTOMER_MERGE_ACCOUNTS": "Both customers have an online account: they cannot be merged.",
  "CUSTOMER_UNAUTHENTICATED": "Sign in to your customer account to continue.",
  "CUSTOMER_INVALID_CREDENTIALS": "Wrong phone, email or password.",
  "CUSTOMER_ACCOUNT_LOCKED": "Too many attempts: try again in a few minutes.",
  "CUSTOMER_TOKEN_INVALID": "This link is invalid or has expired.",
  "ORDER_NOT_EDITABLE": "This order can no longer be changed: it is being prepared, invoiced or waiting for its online payment.",
  "ORDER_TOTAL_BELOW_PAID": "The customer has paid more than this new total: refund the difference first.",
  "ORDER_WRONG_STATUS": "This order is no longer at this stage: reload it to see where it is.",
  "ORDER_INCOMPLETE": "Add at least one line before placing the order.",
  "ORDER_STEP_INVALID": "This step cannot come next for this order.",
  "ORDER_RETURN_LATE": "The return period is over: a manager can still accept the return.",
  "ORDER_RETURN_TOO_MUCH": "More is returned than was sold.",
  "STOCK_UNAVAILABLE": "Not enough stock is available at this site for this order.",
  "PAYMENT_NOT_ALLOWED": "This order cannot take a payment in its current state.",
  "PAYMENT_TOO_MUCH": "This is more than the order still owes.",
  "REFUND_TOO_MUCH": "This is more than the payment has left to give back.",
  "PAYMENT_NOT_VOIDABLE": "This payment can no longer be voided: refund it instead.",
  "PAYMENT_PROVIDER_FAILED": "The payment provider did not accept the request. Try again.",
  "WEBHOOK_SIGNATURE_INVALID": "The webhook signature is not valid.",
  "DOCUMENT_NOT_ALLOWED": "This document cannot be issued for this order now.",
  "REGISTER_NOT_PAIRED": "This browser is not a cash register. A manager pairs it on the Registers page.",
  "REGISTER_INACTIVE": "This register is not in use.",
  "REGISTER_SHIFT_OPEN": "This register has a shift open: close it first.",
  "SHIFT_NOT_OPEN": "This register has no shift open: open the shift first.",
  "SHIFT_ALREADY_OPEN": "A shift is already open here or for you.",
  "SHIFT_NOT_PENDING": "This shift waits for no approval.",
  "STORE_CLOSED": "The online store is closed for now.",
  "CART_NOT_READY": "Some items in the cart cannot be ordered as they are.",
  "CART_FULL": "The cart is full.",
  "POS_DISCOUNT_TOO_LARGE": "This discount is above your limit: ask a manager.",
  "POS_PAYMENTS_MISMATCH": "The payments do not make the total of the ticket.",
  "POS_CHANNEL_INACTIVE": "The counter of this store does not sell (its channel is off).",
  "POS_APPROVAL_REQUIRED": "This needs a manager: ask one to allow it here.",
  "POS_APPROVAL_INVALID": "This approval cannot be used: ask the manager again.",
  "POS_SALE_CANCELLED": "This sale was cancelled already.",
  "POS_NOT_CORRECTABLE": "Only a payment of this register's open shift, not refunded, can be corrected.",
  "MAINTENANCE": "The data is being restored: try again in a moment.",
  "RESTORE_RUNNING": "A restore is already running.",
  "RESTORE_CONFIRMATION": "Type the company name exactly to confirm.",
  "RESTORE_ARCHIVE_INVALID": "This file is not a Light BM backup that can be restored.",
  "RESTORE_NOT_READY": "This file was restored or removed already.",
  "SUPPLIER_INACTIVE": "This supplier is deactivated.",
  "SUPPLIER_PAYMENT_DUPLICATE": "A payment like this one is already recorded.",
  "SUPPLIER_PAYMENT_WRONG_STATUS": "This payment cannot do that any more: it was paid or cancelled meanwhile.",
  "SUPPLIER_PAYMENT_OVER_ALLOCATED": "The payment does not fit these receipts: check the amounts.",
  "RECEIPT_HAS_PAYMENTS": "Payments are allocated to this receipt: cancel them or move them to another receipt first.",
  "AMOUNT_DUE_BELOW_PAID": "Payments already give this receipt more than that amount.",
  "PROMOTION_USED_UP": "A promotion on this sale has just run out. Check the new total.",
  "PROMOTION_USED": "A sale used this promotion: end it instead of deleting it."
}
